'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fragmentSimpleSrc = "#version 100\n#define SHADER_NAME Tiling-Sprite-Simple-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 texSample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = texSample * uColor;\n}\n";

exports["default"] = fragmentSimpleSrc;
//# sourceMappingURL=sprite-tiling-simple.js.map
